import { MDBNav, MDBNavItem, MDBIcon } from "mdbreact";
import { Component } from "react";
import React from "react";
import './InfoHide.css';

class InfoHide2 extends Component {

    render() {
        return (

            <MDBNav tabs className="smallInfoBar2">
                <MDBIcon icon="info-circle" style={{paddingRight:"7px", marginTop:"3px"}} />
                <MDBNavItem>
                    <strong>{this.props.info1}</strong>
                </MDBNavItem>
                <MDBNavItem className="info2">
                   {this.props.info2}
                </MDBNavItem>
                <MDBNavItem className="info2">
                    {this.props.info3}
                </MDBNavItem>
                <MDBNavItem className="info2">
                    {this.props.info4}
                </MDBNavItem>
                <MDBNavItem className="info2">
                    {this.props.info5}
                </MDBNavItem>
            </MDBNav>


        )
    }
}

export default InfoHide2;